import React, { useState } from 'react';
import { Form, Input, Button, Select, DatePicker, Row, Col, notification, Card } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';

const { Option } = Select;
const { TextArea } = Input;

const teams = ['Marketing', 'Sales', 'HR', 'IT'];

const TrainingRequestForm = () => {
  const [requests, setRequests] = useState([{ id: 1, title: '', team: '', description: '', justification: '', date: null }]);

  const handleAddRequest = () => {
    setRequests([...requests, { id: requests.length + 1, title: '', team: '', description: '', justification: '', date: null }]);
  };

  const handleRemoveRequest = (id) => {
    setRequests(requests.filter(request => request.id !== id));
  };

  const handleSubmit = (values) => {
    notification.success({
      message: 'Training Requests Submitted',
      description: 'Your training requests have been submitted successfully!',
    });
    console.log('Submitted Requests:', requests);
  };

  const handleInputChange = (id, field, value) => {
    setRequests(requests.map(request => (request.id === id ? { ...request, [field]: value } : request)));
  };

  return (
    <div>
      <Card title="Submit Training Requests" bordered={false}>
        <Form onFinish={handleSubmit} layout="vertical">
          {requests.map((request, index) => (
            <Card key={request.id} style={{ marginBottom: 16 }} bordered={true}>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Training Title" required>
                    <Input
                      value={request.title}
                      onChange={(e) => handleInputChange(request.id, 'title', e.target.value)}
                      placeholder="Enter training title"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Team" required>
                    <Select
                      value={request.team}
                      onChange={(value) => handleInputChange(request.id, 'team', value)}
                      placeholder="Select team"
                    >
                      {teams.map(team => (
                        <Option key={team} value={team}>
                          {team}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Training Date" required>
                    <DatePicker
                      onChange={(date) => handleInputChange(request.id, 'date', date)}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label="Description" required>
                    <TextArea
                      value={request.description}
                      onChange={(e) => handleInputChange(request.id, 'description', e.target.value)}
                      placeholder="Enter a brief description"
                      rows={3}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label="Justification" required>
                    <TextArea
                      value={request.justification}
                      onChange={(e) => handleInputChange(request.id, 'justification', e.target.value)}
                      placeholder="Provide justification for the training"
                      rows={3}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row justify="end">
                <Button
                  type="danger"
                  icon={<MinusCircleOutlined />}
                  onClick={() => handleRemoveRequest(request.id)}
                  disabled={requests.length === 1}
                >
                  Remove Request
                </Button>
              </Row>
            </Card>
          ))}
          <Row>
            <Button type="dashed" onClick={handleAddRequest} block icon={<PlusOutlined />}>
              Add Another Training Request
            </Button>
          </Row>
          <Row justify="center" style={{ marginTop: 24 }}>
            <Button type="primary" htmlType="submit">
              Submit Requests
            </Button>
          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default TrainingRequestForm;